export interface Tone {
  index: number;
  label: string;
  icon: any;
}

const smartIcon = require('../../../public/img/assessments/microcertificates-emojis/brain.png');
const shoeIcon = require('../../../public/img/assessments/microcertificates-emojis/shoe.png');
const tadaIcon = require('../../../public/img/assessments/microcertificates-emojis/tada.png');
const sunglassesIcon = require('../../../public/img/assessments/microcertificates-emojis/sunglasses.png');
const briefcaseIcon = require('../../../public/img/assessments/microcertificates-emojis/briefcase.png');

export const tones: Tone[] = [
  {
    index: 0,
    label: 'smart',
    icon: smartIcon,
  },
  {
    index: 1,
    label: 'hurry',
    icon: shoeIcon,
  },
  {
    index: 2,
    label: 'festive',
    icon: tadaIcon,
  },
  {
    index: 3,
    label: 'confident',
    icon: sunglassesIcon,
  },
  {
    index: 4,
    label: 'professional',
    icon: briefcaseIcon,
  },
];

export const defaultTone = tones[2];

export const selectKeys = [' ', 'Enter'];
export const previousKeys = ['Up', 'ArrowUp', 'Left', 'ArrowLeft'];
export const nextKeys = ['Down', 'ArrowDown', 'Right', 'ArrowRight'];

export enum EventInteractionType {
  StartShareOnLinkedin = 'Start Share On Linkedin',
  LinkedinPostCreated = 'Linkedin Post Created',
  LinkedinPostFailed = 'Linkedin Post Failed',
  OpenLinkedinCreatedPost = 'Open Linkedin Created Post',
  MicrocertificateDownloaded = 'Microcertificate Downloaded',
  AddToLinkedin = 'Add To Linkedin',
}
